import React, { lazy } from 'react';
import { useSelector } from 'react-redux';

// /dashboard renders one of two dashboards based on role:
//   - seller+warehouse (role 5) AND seller/Admin (role 2) -> the new MarketOS Overview dashboard
//   - everyone else (the plain Warehouse role) -> the original warehouse dashboard
// Both are lazy-loaded; the app-level <Suspense> in App.js provides the fallback.
const SellerDashboard = lazy(() => import('./DashboardContainer.jsx'));
const WarehouseDashboard = lazy(() => import('../dashbaord'));

export default function DashboardSwitch() {
  const role = useSelector((s) => (s.auth && s.auth.currentUser && s.auth.currentUser.role) || {});
  const showSellerDashboard = role.id === 5 || role.id === 2 || role.name === 'seller+warehouse';
  return showSellerDashboard ? <SellerDashboard /> : <WarehouseDashboard />;
}
